import { configureI18n, useInitializeI18n } from '@applyboard/ui-utils';
import { Language } from './locales/Language';
import enUsTranslation from './locales/en-US/translation.json';
import frCaTranslation from './locales/fr-CA/translation.json';

const i18n = {
  [Language.enUS]: { translation: enUsTranslation },
  [Language.frCA]: { translation: frCaTranslation },
};

export const i18nSingleton = configureI18n(i18n);

export function useInitI18n() {
  return useInitializeI18n(i18n);
}
